<acabim-assets-space-selection [selectionType]="'space'"></acabim-assets-space-selection>

<ng-container *ngIf="projectApiService.selectedProjectId$ | async">
    <acabim-card
            cardHeading="Import Space Properties"
            [cardContent]="ImportSpaceProperties"
            [hasHelpButton]="true"
            helpMessage="Import a csv file with a header row to replace existing BIM data. Provide GUID to find existing records to replace."
    ></acabim-card>
</ng-container>

<ng-template #ImportSpaceProperties>
    <div class="p-3">
        <ng-container [ngSwitch]="csvProcessingState">
            <ng-container *ngSwitchDefault>
                <acabim-file-upload #csvUploader [displaySelectedFileName]="true"></acabim-file-upload>
                <button *ngIf="csvUploader.currentState === 0" (click)="startImportSession()">Start</button>
            </ng-container>

            <ng-container *ngSwitchCase="1">
                <acabim-csv-header-mapper [request]="csvMapRequest" (response)="confirmCsvMapRequest($event)"></acabim-csv-header-mapper>
            </ng-container>

            <ng-container *ngSwitchCase="2">
                <acabim-loading-view></acabim-loading-view>
            </ng-container>
        </ng-container>
    </div>
</ng-template>

<p-toast></p-toast>
